import { useEffect } from "react";

/**
 * Focuses `inputRef` whenever `isVisible` becomes true.
 * The short delay lets any open/close animation finish before focusing.
 */
export const useFocusOnVisible = (
    isVisible: boolean,
    inputRef: React.RefObject<HTMLTextAreaElement>
): void => {
    useEffect(() => {
        if (!isVisible) return;
        const id = setTimeout(() => inputRef.current?.focus(), 220);
        return () => clearTimeout(id);
    }, [isVisible, inputRef]);
};
